/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import healthchari1 from '../images/healthchari1.jpg';
import healthchari2 from '../images/healthchari2.jpg';
import healthchari3 from '../images/healthchari3.jpg';
import healthchari4 from '../images/healthchari4.jpg';
import healthchari5 from '../images/healthchari5.jpg';
import healthchari6 from '../images/healthchari6.jpg';
import './ImageGalleryIRCCHARITY.css';

const ImageGalleryIRCCHARITY = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Memoize the imageList array
  const imageList = useMemo(() => [
    { id: 1, image: healthchari1 },
    { id: 2, image: healthchari2 },
    { id: 3, image: healthchari3 },
    { id: 4, image: healthchari4 },
    { id: 5, image: healthchari5 },
    { id: 6, image: healthchari6 },
  ], []);

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setCurrentIndex(0);
  };

  // Memoize the navigation functions
  const goToPrevious = useCallback(() => {
    const newIndex = currentIndex === 0 ? imageList.length - 1 : currentIndex - 1;
    setSelectedImage(imageList[newIndex]);
    setCurrentIndex(newIndex);
  }, [currentIndex, imageList]);

  const goToNext = useCallback(() => {
    const newIndex = currentIndex === imageList.length - 1 ? 0 : currentIndex + 1;
    setSelectedImage(imageList[newIndex]);
    setCurrentIndex(newIndex);
  }, [currentIndex, imageList]);

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      
      if (e.key === 'ArrowLeft') {
        goToPrevious();
      } else if (e.key === 'ArrowRight') {
        goToNext();
      } else if (e.key === 'Escape') {
        closeLightbox();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, currentIndex, goToNext, goToPrevious]); // Include all dependencies

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        {/* Image Grid */}
        <div className="gallery-grid">
          {imageList.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item"
              onClick={() => openLightbox(image, index)}
              style={{ cursor: 'pointer' }}
            >
              <img
                src={image.image}
                // alt={image.title}
                className="gallery-image"
                loading="lazy"
              />
              {/* <div className="image-overlay">
                <span className="image-caption">{image.title}</span>
              </div> */}
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox active" onClick={closeLightbox}>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={closeLightbox}>&times;</button>
            
            {/* Navigation Buttons */}
            <button className="nav-btn prev-btn" onClick={goToPrevious}>
              &#8249;
            </button>
            
            <button className="nav-btn next-btn" onClick={goToNext}>
              &#8250;
            </button>

              <img src={selectedImage.image} 
                
              className="lightbox-image" />
            {/* <div className="lightbox-caption">
              {selectedImage.title} ({currentIndex + 1} of {imageList.length})
            </div> */}
          </div>
        </div>
      )}
    </section>
  );
};

export default ImageGalleryIRCCHARITY;